import { Vue, Component } from 'vue-property-decorator';

/**
 * Create loader, na removes it when children(which i passed as slot) triggers event, thats it's loaded
 */
@Component({
	mounted() {
		this.$on('component:loaded', () => {
			this.isLoading = false;
		});
	}
})
export default class WithLoader extends Vue {
	isLoading: boolean = true;
}
